import { withBemMod } from '@bem-react/core';
import React, { FC, ReactElement } from 'react';
import './Icon_type_nocamera.css';

export interface WithTypeNoCameraProps {
  type?: 'noCamera';
}

export const withTypeNoCamera = withBemMod<WithTypeNoCameraProps>(
    'Icon',
    { type: 'noCamera' },
    (Icon): FC => ((props): ReactElement => (<Icon {...props} />)),
);

export default withTypeNoCamera;
